/**
 * @description: 点歌屏广告位设置
 * @author: lyr
*/
<template>
    <div class="screen_ad_set">
        <div class="list" v-show="showList==1">
            <h1>点歌屏广告位设置</h1>
            <el-form :inline="true">
                <el-form-item label="门店">
                    <el-select v-model="shop_id" filterable>
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="getTable(1)">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="skin_scene" label="应用场景"></el-table-column>
                <el-table-column prop="skin_scene" label="适用皮肤"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="adSet(scope.row)">广告设置</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getTable">
            </el-pagination>
        </div>

        <!-- 广告列表 -->
        <div class="list" v-show="showList==2">
            <h1>{{type_name}}</h1>
            <p class="red-font">1启用相应的广告位时，需先设置广告内容；2 设置启用/禁用后，需重启包厢机顶盒后生效</p>
            <el-form :inline="true">
                <el-form-item class="pull-right">
                    <el-button @click="backSkinList">返回</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="ad_table">
                <el-table-column prop="type_name" label="广告封面样式"></el-table-column>
                <el-table-column prop="title" label="广告标题"></el-table-column>
                <el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<span>{{scope.row.status=='-1'?'禁用':'启用'}}</span>
					</template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="banAd(scope.row)" v-if="scope.row.status==1">禁用</span>
                        <span class="text-blue" @click="openAd(scope.row)" v-if="scope.row.status==-1">启用</span>
                        <span class="text-blue" @click="setAd(scope.row)">设置</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 广告设置详情 -->
        <div class="detail" v-show="showList==3">
            <h1>广告详情设置</h1>
            <div class="ad-title">广告标题：{{ad_title}}</div>
            <el-form :model="ad_form" label-width="120px">
            	<el-form-item label="广告封面样式" required>
                    <el-select v-model="ad_form.type" clearable placeholder="请选择广告封面样式" @change="changeType">
                        <el-option label="1张长图" value="1"></el-option>
                        <el-option label="2张大图" value="2"></el-option>
                        <el-option label="多图轮播" value="3"></el-option>
                        <el-option label="商品菜单墙" value="4"></el-option>
                        <el-option label="商品套餐墙" value="5"></el-option>
                    </el-select>
                </el-form-item>
                <div class="block-item" v-for="(item, index) in ad_form.content" v-if="ad_form.type!='4'&&ad_form.type!='5'">
                	<p>图{{index+1}}</p>
                	<img class="delete-icon" 
	                	src="../../assets/images/scrn_del.png" 
	                	v-if="ad_form.type=='3'&&ad_form.content.length>3"
	                	@click="deleteThisImg(index)" 
                	/>
                	<el-form-item label="广告封面" required>
	                  	<span>{{ad_form.type=='1'?'图片比例长1020*宽140，大小不超过2m': '图片比例1920*1080，大小不超过2M'}}</span>
	                  	<div class="img-wrapper" :class="{'big-img':ad_form.type=='1'}" v-if="item.img==''" :id="'faceImg'+index">
	                  		<img src="../../assets/images/icon_add.png" alt="" class="add-icon">
							<div class="add-txt">点击上传图片</div>
	                  	</div>
	                  	<div class="img-wrapper" :class="{'big-img':ad_form.type=='1'}" v-else :id="'faceImg'+index">
	                  		<img :src="item.img" alt="" class="ad-img">
	                  	</div>
	                </el-form-item>
	                <el-form-item label="广告详情样式" required>
	                  	<el-radio v-model="item.content_type" label="1" @change="(val)=>contentTypeChange(val, index)">无</el-radio>
  						<el-radio v-model="item.content_type" label="2" @change="(val)=>contentTypeChange(val, index)">图片</el-radio>
  						<!-- <el-radio v-model="item.content_type" label="3" @change="(val)=>contentTypeChange(val, index)">视频</el-radio> -->
  						<el-radio v-model="item.content_type" label="4" @change="(val)=>contentTypeChange(val, index)">商品详情</el-radio>
  						<div class="red-tip">{{item.content_type=='1'?'点击广告封面无任何响应':item.content_type=='2'?'点击广告封面后，则进入广告详情页，并显示上传的图片':item.content_type=='3'?'点击广告封面后，则进入广告详情页，并显示上传的视频':'点击广告封面后，则弹窗商品详情页，可查看商品大图，并可支持直接扫码付费购买'}}</div>
	                </el-form-item>
	                <el-form-item label="广告详情页内容" v-if="item.content_type=='2'">
	                	<span>{{skin_type=='vertical'?'图片比例1080*1920，大小不超过2M':'图片比例1920*1080，大小不超过2M'}}</span>
	                	<div class="img-wrapper normal-img" v-if="item.content_url==''" :id="'contentImg'+index">
	                  		<img src="../../assets/images/icon_add.png" alt="" class="add-icon">
							<div class="add-txt">点击上传图片</div>
	                  	</div>
	                  	<div class="img-wrapper normal-img" v-else :id="'contentImg'+index">
	                  		<img :src="item.content_url" alt="" class="content-img">
	                  	</div>
	                </el-form-item>
	                <el-form-item label="广告详情页内容" v-if="item.content_type=='3'">
	                	<span>上传视频格式需为：mkv/mp4/avi，如上传格式不符合将无法正常播放。视频分辨率不能超过1080p，单个文件大小不能超过200m</span>
	                	<div class="video-wrapper" v-if="item.content_url==''" :id="'contentVideo'+index">
	                  		<img src="../../assets/images/icon_add.png" alt="" class="add-icon">
							<div class="add-txt">点击上传视频</div>
	                  	</div>
	                  	<div class="video-wrapper" v-else :id="'contentVideo'+index">
	                  		<video :src="item.content_url" alt="" class="video" controls></video>
	                  	</div>
	                </el-form-item>
	                <el-form-item label="广告详情页内容" v-if="item.content_type=='4'">
	                	<div class="row" v-if="!item.goods||!item.goods.goods_img">
		                	<div class="img-wrapper goods" @click="openGoodPop(1, index)">
		                  		<img src="../../assets/images/icon_add.png" alt="" class="add-icon">
								<div class="add-txt">点击添加商品</div>
		                  	</div>
		                  	<div class="goods-detail">
		                  		<div class="row">商品类型：</div>
		                  		<div class="row">商品名称：</div>
		                  		<div class="row">原价：</div>
		                  		<div class="row">优惠价：</div>
		                  	</div>
	                	</div>
	                	<div class="row" v-else>
		                  	<div class="img-wrapper goods" @click="openGoodPop(1, index)">
		                  		<img :src="item.goods.goods_img" alt="" class="good-img">
		                  	</div>
		                  	<div class="goods-detail">
		                  		<div class="row">商品类型：{{item.goods.goods_type_name}}</div>
		                  		<div class="row">商品名称：{{item.goods.goods_name}}</div>
		                  		<div class="row">原价：{{item.goods.cost_price}}</div>
		                  		<div class="row">优惠价：{{item.goods.discount_price}}</div>
		                  	</div>
	                	</div>
	                </el-form-item>
                </div>
                <el-form-item v-if="ad_form.type=='3'">
	                <el-button type="primary" @click="addImg">新增图片</el-button>
	            </el-form-item>
	            <!-- 商品 -->
	            <div class="block-item" v-for="(item, index) in ad_form.content" v-if="ad_form.type=='4'">
	            	<el-form-item :label="'商品-'+(index+1)" required label-width="80px"></el-form-item>
	            	<div class="good-row" v-if="!item.goods||!item.goods.goods_img">
						<div class="img-wrapper goods" @click="openGoodPop(3, index)">
							<img src="../../assets/images/icon_add.png" alt="" class="add-icon">
							<div class="add-txt">点击添加商品</div>
						</div>
						<div class="goods-detail">
	                  		<div class="row">商品类型：</div>
	                  		<div class="row">商品名称：</div>
	                  		<div class="row">原价：</div>
	                  		<div class="row">优惠价：</div>
	                  	</div>
	            	</div>
	            	<div class="good-row" v-else>
						<div class="img-wrapper goods" @click="openGoodPop(3, index)">
							<img :src="item.goods.goods_img" alt="" class="good-img">
						</div>
						<div class="goods-detail">
	                  		<div class="row">商品类型：{{item.goods.goods_type_name}}</div>
	                  		<div class="row">商品名称：{{item.goods.goods_name}}</div>
	                  		<div class="row">原价：{{item.goods.cost_price}}</div>
	                  		<div class="row">优惠价：{{item.goods.discount_price}}</div>
	                  	</div>
	            	</div>
	            </div>
	            <!-- 套餐 -->
	            <div class="block-item" v-for="(item, index) in ad_form.content" v-if="ad_form.type=='5'">
	            	<el-form-item :label="'商品套餐-'+(index+1)" required></el-form-item>
	            	<div class="good-row" v-if="!item.goods||!item.goods.goods_img">
						<div class="img-wrapper" @click="openGoodPop(2, index)">
							<img src="../../assets/images/icon_add.png" alt="" class="add-icon">
							<div class="add-txt">点击添加套餐</div>
						</div>
						<div class="goods-detail">
	                  		<div class="row">商品套餐类型：</div>
	                  		<div class="row">商品套餐名称：</div>
	                  		<div class="row">原价：</div>
	                  		<div class="row">优惠价：</div>
	                  	</div>
	            	</div>
	            	<div class="good-row" v-else>
						<div class="img-wrapper" @click="openGoodPop(2, index)">
							<img :src="item.goods.goods_img" alt="" class="good-img">
						</div>
						<div class="goods-detail">
	                  		<div class="row">商品套餐类型：{{item.goods.goods_type_name}}</div>
	                  		<div class="row">商品套餐名称：{{item.goods.goods_name}}</div>
	                  		<div class="row">原价：{{item.goods.cost_price}}</div>
	                  		<div class="row">优惠价：{{item.goods.discount_price}}</div>
	                  	</div>
	            	</div>
	            </div>
	            <el-form-item>
	                <el-button @click="backtoAdList">返回</el-button>
	                <el-button type="primary" @click="adEdit">确定</el-button>
	            </el-form-item>
	        </el-form>
        </div>
        <!-- 添加商品弹窗 -->
        <div class="add-good-pop" ref="add_good_pop">
        	<el-row :gutter="20">
				<el-col :span="8">
					<el-select v-model="goods_type" clearable filterable placeholder="请选择类型" @change="goodsTypeChange">
						<el-option v-for="item in all_type_list"  :label="item.name" :value="item.id" v-if="needShow==1"></el-option>
						<el-option v-for="item in package_type_list" :label="item.name" :value="item.id" v-if="needShow==2"></el-option>
						<el-option v-for="item in goods_type_list"  :label="item.name" :value="item.id" v-if="needShow==3"></el-option>
					</el-select>
				</el-col>
				<el-col :span="10">
					<el-input placeholder="请输入商品名称" v-model="goods_name"></el-input>
				</el-col>
				<el-col :span="6">
					<el-button class="pull-right" type="primary" @click="getGoodsTable(1)">查询</el-button>
				</el-col>
			</el-row>
			<el-table
				v-if="goods_type_sign=='package'"
				v-loading="goods_loading"
				element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				ref="goods_table"
				:data="goods_table"
				@selection-change="getSelectGoods">
				<el-table-column type="selection"></el-table-column>
				<el-table-column prop="goods_type_name" label="类型"></el-table-column>
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="package_unit_name" label="单位"></el-table-column>
			</el-table>
			<el-table
				v-else
				v-loading="goods_loading"
				element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				ref="goods_table"
				:data="goods_table"
				@selection-change="getSelectGoods">
				<el-table-column type="selection"></el-table-column>
				<el-table-column prop="goods_type_name" label="类型"></el-table-column>
				<el-table-column prop="goods_name" label="名称"></el-table-column>
				<el-table-column prop="goods_unit_name" label="单位"></el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="goods_page_size"
				:current-page.sync="goods_page"
				:total="goods_total"
				@current-change="getGoodsTable">
			</el-pagination>
        </div>
    </div> 
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'screen_ad_set',
        data() {
            return {
                showList: 1,
                loading: false,
                shop_list: [],
                shop_id: '',
                list_page: 1,
				list_total: 0,
                list_table: [],

                type_name: '', // 应用场景名称
                skin_key: '',
                ad_table: [], 
				skin_type: '', // 横竖屏

                category_id: '',
                ad_title: '',  
                ad_form: {
                	type: '1', //1：1张大图 2：2张大图 3多图轮播 4商品
                	content: [{
	                    id: 0,//id 如果是新增的传0
	                    img: "",//广告封面
	                    content_url: "",//广告内容 type=4的时候传空或者不传
	                    content_type: '1',//广告内容样式 1无 2图片 3视频 4商品详情 如果type选择4这边也需要传4
	                    goods_type: "",//商品类型1普通商品 2商品套餐 type不为4的时候不传或者传0,
	                    goods_id: ""//商品id type不为4的时候不传或者传0
                	}],
                },
                plupload_list: [],

                goods_type: '',
                goods_name: '',
                goods_type_list: [], // 商品类型
                package_type_list: [], // 套餐类型
                all_type_list: [], // 全部类型
                goods_type_sign: '',
                goods_loading: false,
                goods_page: 1,
                goods_total: 0,
                goods_page_size: 5,
                goods_table: [],
                needShow: 1, // 1全部类型 2套餐类型 3商品类型 
                popGood: [],
            }
        },
        mounted: function() {
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.shop_id = this.shop_list[0].id
                this.getTable(1)
            })
        },
        methods: {
            // 获取门店数据
			getShop: function(resolve) {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
                    console.log(err);
					layer.msg('出错啦');
				});
            },

            // 列表
			getTable: function(page) {
				const _this = this;
				_this.loading = true;
				Vue.axios.post('ScreenSkin/getSkinList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.shop_id,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.list_total = Number(res.data.response.result.total)
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },

            // 点击列表“广告设置”
            adSet: function (row) {
            	this.type_name = row.type_name
            	this.skin_key = row.skin_key
				this.skin_type = row.skin_key.indexOf('_vertical') > -1 ? 'vertical' : row.skin_key.indexOf('_horizon') > -1 ? 'horizon' : ''
            	this.getShopAdList()
            	this.showList = 2
            },

            backSkinList: function () {
            	this.showList = 1
            },

            // 获取皮肤样式列表
            getShopAdList: function() {
				const _this = this;
				_this.loading = true;
				Vue.axios.post('ScreenSkin/getShopAdList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"skin_key": _this.skin_key,
                            "shop_id": _this.shop_id,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.ad_table = res.data.response.result;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },

            // 启用
            openAd: function(row) {
            	let _this = this;
            	if (row.set_content == -1) {
            		layer.confirm('您还未设置广告内容，请先“前往设置”进行广告内容设置！', {
						title: ['提示', true],
						btn: ['前往设置', '取消'],
					}, function() {
						layer.closeAll()
						_this.showList = 3
						_this.category_id = row.category_id
						_this.ad_title = row.title
					});
            	}else {
            		layer.confirm('启用后，包厢触摸屏将显示该广告内容。确认启用？', {
						title: ['提示', true],
						btn: ['确定', '取消'],
					}, function() {
						Vue.axios.post('ScreenSkin/upShopAdStatus', {
							"header": Vue.request_header,
							"request": {
								"param": {
									"category_id": row.category_id,
		            				"shop_id": _this.shop_id,
		            				"status": 1
								}
							},
							"comment": ""
						})
						.then(res => {
							if(res.data.response.result_code == "true") {
								layer.msg('操作成功');
								_this.getShopAdList();
							} else {
								Vue.timeoutfun(res.data.response.result_status, _this)
								layer.msg(res.data.response.error_msg)
							}
						})
						.catch(err => {
							layer.msg("出错啦")
						})
					});
            	}
            },

            // 禁用
            banAd: function (row) {
            	let _this = this
            	layer.confirm('禁用后，包厢触摸屏将不显示该广告内容。确认禁用？', {
					title: ['提示', true],
					btn: ['确定', '取消'],
				}, function() {
					Vue.axios.post('ScreenSkin/upShopAdStatus', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"category_id": row.category_id,
	            				"shop_id": _this.shop_id,
	            				"status": -1
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.getShopAdList();
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this)
							layer.msg(res.data.response.error_msg)
						}
					})
					.catch(err => {
						layer.msg("出错啦")
					})
				});
            },

            setAd: function (row) {
            	this.showList = 3
				this.category_id = row.category_id
				this.ad_title = row.title
				this.goods_type_list = []// 商品类型
                this.package_type_list = [] // 套餐类型
                this.all_type_list = [] // 全部类型
				this.getAdDetail()
				this.getGoodsPackageType() // 获取套餐类型
				// this.getGoodsType()
            },

            // 获取广告设置详情
            getAdDetail: function () {
            	const _this = this

				_this.loading = true
				Vue.axios.post('ScreenSkin/getShopAd', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"category_id": _this.category_id,
            				"shop_id": _this.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.ad_form = {
							type: res.data.response.result.type,
							content: res.data.response.result.content
						}
						_this._formateUploadDom()
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
            },

            backtoAdList: function () {
            	this.showList = 2
            },

           	// 整理需要初始化上传的dom
           	_formateUploadDom: function () {
           		if (this.ad_form.content.length > 0 && (this.ad_form.type == '1' || this.ad_form.type == '2' || this.ad_form.type == '3')) {
           			this.ad_form.content.forEach((item, index) => {
           				this.initUpload('faceImg' + index, index, 'img')
           				if (item.content_type == '2') { // 广告内容是图片
           					this.initUpload('contentImg' + index, index, 'img')
           				}else if (item.content_type == '3') { // 广告内容是视频
           					this.initUpload('contentVideo' + index, index, 'video')
           				}
           			})
           		}
           	},

           	// 销毁不必要的Plupload实例
           	destroyPlupload: function () {
           		console.log('destroyPlupload')
           		if(this.plupload_list.length > 0) {
           			this.plupload_list.forEach(v => {
           				v.destroy()
           			})
           			this.plupload_list = []
           		}
           	},

            // 点击“确定”
            adEdit: function () {
            	let _this = this
            	Vue.axios.post('ScreenSkin/editShopAd', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"category_id": _this.category_id,
            				"shop_id": _this.shop_id,
            				"type": _this.ad_form.type,
				            "content": _this.ad_form.content
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg("操作成功！")
						_this.showList = 2
						_this.getShopAdList()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
            },

            // 切换菜单样式类型
            changeType: function (val) {
            	if (val == '1') {
            		this.ad_form = {
            			type: '1',
            			content: [{
		                    id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '1',
		                    goods_type: '',
		                    goods_id: ''
	                	}]
            		}
            	}else if(val == '2') {
            		this.ad_form = {
            			type: '2',
            			content: [{
		                    id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '1',
		                    goods_type: '',
		                    goods_id: ''
	                	},{
		                    id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '1',
		                    goods_type: '',
		                    goods_id: ''
	                	}]
            		}
            	}else if(val == '3') {
            		this.ad_form = {
            			type: '3',
            			content: [{
		                    id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '1',
		                    goods_type: '',
		                    goods_id: ''
	                	},{
		                    id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '1',
		                    goods_type: '',
		                    goods_id: ''
	                	},{
		                    id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '1',
		                    goods_type: '',
		                    goods_id: ''
	                	}]
            		}
            	}else if(val == '4') {
            		this.ad_form = {
            			type: '4',
            			content: [{
            				id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '4',
		                    goods_type: '',
		                    goods_id: ''
            			},{
            				id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '4',
		                    goods_type: '',
		                    goods_id: ''
            			},{
            				id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '4',
		                    goods_type: '',
		                    goods_id: ''
            			},{
            				id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '4',
		                    goods_type: '',
		                    goods_id: ''
            			},{
            				id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '4',
		                    goods_type: '',
		                    goods_id: ''
            			},{
            				id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '4',
		                    goods_type: '',
		                    goods_id: ''
            			}]
            		}
            	}else if (val == '5') {
            		this.ad_form = {
            			type: '5',
            			content: [{
            				id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '4',
		                    goods_type: '',
		                    goods_id: ''
            			},{
            				id: 0,
		                    img: '',
		                    content_url: '',
		                    content_type: '4',
		                    goods_type: '',
		                    goods_id: ''
            			}]
            		}
            	}
            	this.destroyPlupload()
            	this._formateUploadDom()
            },

            addImg: function () {
            	this.ad_form.content.push({
            		id: 0,
                    img: '',
                    content_url: '',
                    content_type: '1',
                    goods_type: '',
                    goods_id: ''
            	})

            	this.initUpload('faceImg' + (this.ad_form.content.length - 1), this.ad_form.content.length - 1, 'img')
            },

            // (多图轮播）删除图片
            deleteThisImg: function (index) {
            	this.ad_form.content.splice(index, 1)
            	this.plupload_list.splice(index,1)
            	this.plupload_list[index].destroy()
            },

            // 初始化上传图片/视频
			initUpload: function(btnName, index, type) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';
				let allow_type = type == 'img' ? 'jpg,jpeg,png,gif' : 'mp4,mkv,m4v,avi'
				let resize_width = '',
					resize_height = '';
				if(btnName.indexOf("faceImg") > -1) {
					resize_width = 1920
					resize_height =  1080 
				}else if(btnName.indexOf("contentImg") > -1) {
					resize_width = this.skin_type == 'vertical' ? 1080 : this.skin_type == 'horizon' ? 1920 : ''
					resize_height = this.skin_type == 'vertical' ? 1920 : this.skin_type == 'horizon' ? 1080 : ''
				}

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: btnName, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: allow_type }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: resize_width,
							height: resize_height
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'system_set'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                let file_url = host + "/" + dir + file_name
                                console.log("文件上传成功：", file_url)
                                if (btnName.indexOf("faceImg") > -1) {
                                	_this.ad_form.content[index].img = file_url
                                }else if (btnName.indexOf("contentImg") > -1) {
                                	_this.ad_form.content[index].content_url = file_url
                                }else if (btnName.indexOf("contentVideo") > -1) {
                                	_this.ad_form.content[index].content_url = file_url
                                }
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传'+ allow_type +'文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							},
							// 初始化完成触发
							PostInit: function () {
								if (btnName.indexOf("content") > -1) {
									if (_this.ad_form.content[index].uploader_list && _this.ad_form.content[index].uploader_list.length > 0) {
										_this._destroyContentUploader(index)
										_this.ad_form.content[index].uploader_list.push(uploader)
									}else {
										_this.$set(_this.ad_form.content[index], 'uploader_list', [uploader])
									}
								}else {
									_this.plupload_list.push(uploader)
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },

            _destroyContentUploader: function (index) {
        		this.ad_form.content[index].uploader_list.forEach(v => {
        			v.destroy()
        		})
        		this.ad_form.content[index].uploader_list = []
            },

       		// 切换广告内容类型
       		contentTypeChange: function (val, index) {
       			this.$nextTick(() => {
       				if (val == '1' || val == '4') { // 无、商品
       					if (this.ad_form.content[index].uploader_list && this.ad_form.content[index].uploader_list.length > 0) {
       						this._destroyContentUploader(index)
       					}
       				}else if (val == '2') { // 图片
	       				this.initUpload("contentImg" + index, index, 'img')
	       			}else if (val == '3') { // 视频
	       				this.initUpload("contentVideo" + index, index, 'video')
	       			}
       			})
       		},

       		// 获取套餐类型
       		getGoodsPackageType() {
				const _this = this;

				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.package_type_list.push({
								id: 'package' + v.id,
								name: v.name
							});
						});
						_this.package_type_list.unshift({
							id: 'package0',
							name: '商品套餐'
						});
						_this.getGoodsType();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
           
           	// 获取商品类型
           	getGoodsType: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getGoodsType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: v.id,
								name: v.name
							});
						});
						_this.all_type_list = _this.package_type_list.concat(_this.goods_type_list)
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			goodsTypeChange: function (val) {
				console.log("goodsTypeChange:", val)
				if (val.indexOf('package') > -1) {
					this.goods_type_sign = 'package'
				}else {
					this.goods_type_sign = ''
				}
				this.goods_type = val
				this.goods_page = 1
				this.goods_total = 0
				this.goods_table = []
				this.getGoodsTable(this.goods_page)
			},
			getGoodsTable: function(page) {
				const _this = this

				_this.goods_loading = true
				let url = "merchantGoods/searchMerchantGoodsList"
				let goods_type = _this.goods_type.indexOf("package") > -1 ? _this.goods_type.split("package")[1] : _this.goods_type
				if(_this.goods_type_sign == 'package') {
					url = "merchantGoods/searchMerchantGoodsPackage";
				}
				let data = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.goods_page_size,
							"shop_id": _this.shop_id,
							"goods_type": goods_type,
							"goods_name": _this.goods_name,
							"status": '1'
						}
					},
					"comment": ""
				};
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.goods_total = Number(res.data.response.result.data.total);
						}
						_this.goods_table = res.data.response.result.data.rows;
						_this.goods_loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			openGoodPop: function (needShow, index) {
				const _this = this;

				_this.goods_type = '';
				_this.goods_name = '';
				_this.goods_page = 1;
				_this.goods_total = 0;
				_this.goods_table = [];
				_this.goods_type_sign = needShow == '2' ? 'package' : '';
				_this.needShow = needShow;
				_this.getGoodsTable(_this.goods_page);
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加商品', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.add_good_pop)
                }, function() {
                	_this.ad_form.content[index].goods_type = _this.goods_type_sign == 'package' ? '2' : '1'
                	_this.ad_form.content[index].goods_id = _this.popGood.id
                	let goods = {
                		goods_type_name: _this.popGood.goods_type_name,//商品类型
	                    goods_name: _this.popGood.goods_name || _this.popGood.name,//商品名称
	                    cost_price: _this.popGood.cost_price || _this.popGood.price,//原价
	                    discount_price: _this.popGood.discount_price || _this.popGood.actual_price,//优惠价
	                    goods_img: _this.popGood.good_img || _this.popGood.img_url//商品图片
                	}
                	_this.$set(_this.ad_form.content[index], 'goods', goods)
                	layer.closeAll()
                })
			},

			// 选择弹窗商品
			getSelectGoods: function(val) {
				console.log(val)
				if (val.length > 1) {
					this.$refs.goods_table.clearSelection()
					this.$refs.goods_table.toggleRowSelection(val.pop())
				}else {
					this.popGood = val.pop()
				}
			},
        }
    }
</script>
<style lang="less" scoped>
    .list {
    	.red-font {
    		color: red;
    		margin-bottom: 10px;
    	}
    }
    .detail {
    	.ad-title {
    		font-size: 16px;
    		margin: 0 0 20px 10px;
    	}
    	.block-item {
    		position: relative;
    		width: 900px;
    		margin: 0 0 20px 10px;
    		padding: 15px;
    		background: rgb(242,242,242);
    		.delete-icon {
    			position: absolute;
    			right: 0;
    			top: 0;
    			width: 20px;
    			height: 20px;
    			padding: 15px;
    			box-sizing: content-box;
    		}
    		.good-row {
    			margin-bottom: 10px;
    			display: flex;
    			flex-direction: row;
    			align-items: center;
    			.img-wrapper {
    				margin: 0 20px 0 10px;
    				.add-icon {
    					margin-bottom: 10px;
    				}
    			}
    			.goods-detail {
    				.row {
    					margin-top: 15px;
    				}
    			}
    		}
    	}
    	.row {
    		display: flex;
    		flex-direction: row;
    		.goods-detail {
    			margin-left: 20px;
    		}
    	}
    	.img-wrapper,
    	.video-wrapper {
    		width: 320px;
			height: 180px;
    		background: #fff;
			border: 1px solid #ccc;
    		display: flex;
    		flex-direction: column;
    		align-items: center;
    		justify-content: center;
    		&.big-img {
    			width: 680px;
    			height: 94px;
    		}
    		&.goods {
    			width: 150px;
    			height: 150px;
    		}
    		.add-icon {
    			width: 40px;
    			height: 40px;
    			margin: 0;
    		}
    		.add-txt {
    			font-size: 12px;
    			color: #999;
    		}
    		.ad-img {
    			width: 100%;
    			height: 100%;
    			margin: 0;
    		}
    		.good-img {
    			width: 100%;
    			height: 100%;
    			margin: 0;
    		}
    		.content-img {
    			width: 100%;
    			height: 100%;
    			margin: 0;
    		}
    		.video {
    			width: 100%;
    			height: 100%;
    			margin: 0;
    		}
    	}
		.red-tip {
			font-size: 12px;
			color: red;
		}
    }
    .add-good-pop {
		display: none;
	}
</style>